import React from "react";
import PropTypes from "prop-types";
import {Avatar, Box, Typography} from "@mui/material";
import InboxIcon from "@mui/icons-material/Inbox";

const OptionalContent = props => {
    const {hasContent, noContentMessage, showIcon, children} = props;
    const avatarSize = 80;

    if (hasContent) {
        return (
            <React.Fragment>
                {children}
            </React.Fragment>
        )
    } else {
        return (
            <Box sx={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                alignContent: "center",
            }}>
                {
                    showIcon &&
                    <Box sx={{p: 2}}>
                        <Avatar style={{width: `${avatarSize}px`, height: `${avatarSize}px`}}>
                            <InboxIcon/>
                        </Avatar>
                    </Box>
                }

                {
                    noContentMessage &&
                    <Typography variant="overline" textAlign='center'>
                        {noContentMessage}
                    </Typography>
                }
            </Box>
        )
    }
};

OptionalContent.propTypes = {
    hasContent: PropTypes.bool.isRequired,
    noContentMessage: PropTypes.string,
    showIcon: PropTypes.bool
};

export {OptionalContent};